<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Multicast</h4>
        <el-form 
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable IGMP Snooping:">
                <el-switch v-model="IGMPSnoop" ></el-switch>
            </el-form-item>
			<el-form-item label="Enable IGMP Proxy:">
                <el-switch v-model="IGMPProxy" ></el-switch>
            </el-form-item>
            <el-form-item label="Enable MLD Snooping:">
                <el-switch v-model="MLDSnoop" ></el-switch>
            </el-form-item>
            <el-form-item label="Enable MLD Proxy:">
                <el-switch v-model="MLDProxy" ></el-switch>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="setData">Apply</el-button>
            </el-form-item>
        </el-form>
        

    </div>
</template>

<script>
export default {
	data() {
        return {
            loading: false,
			IGMPSnoop:false,
			IGMPProxy:false,
			MLDSnoop:false,
			MLDProxy:false,
        }
    },
    created(){
        this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            axios
            .post("/JSONAPI",{cmdType:"GET_WEB_MULTICAST"})
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.IGMPSnoop = response.data.IGMPSnoop
					this.IGMPProxy = response.data.IGMPProxy
					this.MLDSnoop = response.data.MLDSnoop
					this.MLDProxy = response.data.MLDProxy
                }
                else
                    this.$message.error(`GET data failed!Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('GET data failed! Network connection error!')
            })
        },
        setData(){
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"SET_WEB_MULTICAST",
                IGMPSnoop:this.IGMPSnoop,
				IGMPProxy:this.IGMPProxy,
				MLDSnoop:this.MLDSnoop,
				MLDProxy:this.MLDProxy
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.$message.success('Configuration is success!')
                }
                else
                    this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('SET Multicast failed! Network connection error!')
            })
        },
    }

}
</script>




